<!-- 支出 -->
<template>
  <div>
    <div class="expend">
      <div class="leftLine1">
        <p class="p1">订单类型</p>
        <div class="line"></div>
        <div class="rightBox">
          <div class="left">
            <div v-for="(item, index) in btnList" :key="index">
              <el-button v-if="item.code != 2"
                @click="init.q.status = item.code, init.q.splitStatus = ['1A'], init.page = 1, myExpensesList()"
                class="btns1" :class="init.q.status == item.code ? 'active' : ''" size="small"
                style="margin-right: 0.1rem" plain>{{
                  item.name
                }}（{{ item.num }}）</el-button>
              <el-popover style="margin-right: 0.1rem;" v-else placement="bottom" width="100" trigger="click">
                <div class="selsectBox">
                  <p @click="init.q.splitStatus = item.value, myExpensesList()"
                    :class="JSON.stringify(init.q.splitStatus) == JSON.stringify(item.value) ? 'active' : ''"
                    v-for="(item, index) in options" :key="index">{{ item.label }}</p>
                </div>
                <el-button size="small" slot="reference"
                  @click="init.q.status = item.code, init.q.splitStatus = ['2A'], init.page = 1, myExpensesList()"
                  class="btns1" :class="init.q.status == item.code ? 'active' : ''">{{
                    item.name
                  }}（{{ item.num }}） <i class="el-icon-arrow-down"></i></el-button>
              </el-popover>
            </div>
          </div>
          <div class="right">
            <el-button class="btns1" size="small">重置</el-button>
            <el-button style="background-color: #db6e33; color: #fff" size="small">搜索</el-button>
          </div>
        </div>
      </div>
      <div class="leftLine1">
        <p class="p1">查询关键词</p>
        <div style="height: 1rem" class="line"></div>
        <div class="rightBox1">
          <div style="display: flex; align-items: center; margin-bottom: 0.2rem">
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="订单编号"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="团号"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="C端达人"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="新客"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="用户账号"></el-input>
            <el-input size="small" style="width: 1.5rem; margin-right: 0.1rem" placeholder="下单企业名"></el-input>
            <el-input size="small" style="width: 2rem; margin-right: 0.1rem" placeholder="请输入支付方交易单号"></el-input>
            <el-date-picker size="small" style="margin-right: 0.1rem;width: 1.7rem;" v-model="value" type="date"
              placeholder="选择下单日期">
            </el-date-picker>
            <el-date-picker style="margin-right: 0.1rem;width: 1.7rem;" size="small" v-model="value" type="date"
              placeholder="选择付款日期">
            </el-date-picker>
          </div>
          <div style="display: flex; align-items: center">
            <p>金额：</p>
            <el-radio-group style="margin-right: 0.8px">
              <el-radio :label="3">
                <span style="margin-right: 5px">大于等于</span>
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
              </el-radio>
              <el-radio :label="9">
                <span style="margin-right: 5px">小于等于</span>
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
              </el-radio>
              <el-radio :label="6">
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
                <span style="margin-right: 0.06rem">至</span>
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="footTitle">
        <div class="footTitleLeft">
          <p class="p1">自己的订单列表（我的支出）</p>
          <p class="p2">符合条件共：</p>
          <p class="p2">订单数（{{ AllpagesNum }}）</p>
          <p class="p2">订单总额（<span>¥{{ totalAmount }}</span>）</p>
        </div>
        <div class="footTitleRight">
          <el-button size="small" class="btns3">导出</el-button>
          <!-- <el-button size="mini" type="primary" @click="openInvoice({})" >开发票</el-button> -->
        </div>
      </div>
      <div style="border: 1px solid #ebeef5">
        <el-table v-loading="loading" border :header-cell-style="{
          backgroundColor: '#FDEFE7', color: '#000000'
        }" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column fixed="left" align="center" type="selection" width="55"> </el-table-column>
          <el-table-column fixed="left" width="180" prop="orderMainId" align="center" label="订单编号"> </el-table-column>
          <el-table-column fixed="left" width="80" prop="planId" align="center" label="团号"> </el-table-column>
          <el-table-column width="150" align="center" label="下单时间">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormatHms }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="订单来源">
            <template slot="header" slot-scope="scope">
              <el-popover placement="bottom" width="200" trigger="click">
                <div>
                  <p v-for="(item, index) in options1" :key="index">{{ item.label }}</p>
                </div>
                <p slot="reference" style="display: flex;align-items: center;cursor: pointer;">订单来源
                  <i class="el-icon-arrow-down"></i>
                </p>
              </el-popover>
            </template>
            <template slot-scope="scope">
              {{ scope.row.orderType == 0 ? 'pc端订单' : '小程序订单' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="支付方式">
            <template slot-scope="scope">
              {{ scope.row.payMode ? payModeType[scope.row.payMode] : '未支付' }}
            </template>
          </el-table-column>
          <el-table-column width="160" align="center" label="订单状态">
            <template slot-scope="scope">
              <!-- <p style="color: red;">操作中</p>
              <el-popover @show="handlerOrderStatusClick(scope.row)" v-if="scope.row.status == 2" placement="top-start"
                width="200" trigger="click">
                <div style="display: flex;align-items: center;flex-direction: column;">
                  <p style="font-size: 0.12rem;margin-bottom: 0.05rem;">{{ scope.row.id }}</p>
                  <div v-for="(n, m) in statusDatas" :key="m" style="font-size: 0.12rem;margin-bottom: 0.05rem;">
                    <span style="color: red;margin-right: 0.2rem;">{{ n.statusText }}</span>
                    <span style="color: #3A8477;">{{ n.num }}个子订单</span>
                  </div>
                  <el-button size="mini" @click="handlerSeeOrderClick" type="primary">查看订单</el-button>
                </div>
                <p slot="reference" style="color: rgb(0, 111, 255);cursor: pointer;">状态说明</p>
              </el-popover>
              <span v-else>
                {{ scope.row.status == 3 ? '已关闭' : '待支付' }}
              </span> -->
              <div v-for="(n, m) in scope.row.statusDescription" :key="m"
                style="font-size: 0.12rem;margin-bottom: 0.05rem;">
                <span style="color: red;margin-right: 0.2rem;">{{ n.statusText }}</span>
                <span style="color: #3A8477;">{{ n.num }}个子订单</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="remark" width="300" label="我的留言">
          </el-table-column>
          <el-table-column align="center" label="订单金额">
            <template slot-scope="scope">
              <span style="color: rgb(216, 27, 67);">{{ scope.row.currency + scope.row.orderPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="优惠活动减免">
            <template slot-scope="scope">
              <span style="color: rgb(216, 27, 67);">{{ scope.row.currency +
                scope.row.couponPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="积分抵扣">
            <template slot-scope="scope">
              <span style="color: rgb(216, 27, 67);">{{ scope.row.currency +
                scope.row.integralPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="支付金额">
            <template slot-scope="scope">
              <span v-if="scope.row.payPrice" style="color: rgb(216, 27, 67);">{{ scope.row.currency + scope.row.payPrice
              }}</span>
              <span style="color: rgb(216, 27, 67);" v-else>未支付</span>
            </template>
          </el-table-column>
          <el-table-column width="210" fixed="right" align="center" label="操作">
            <template slot-scope="scope">
              <el-button @click="handlerSeeOrderClick(scope.row)" size="mini" type="primary">查看订单</el-button>
              <el-button v-if="scope.row.orderMainStatus == 3 && JSON.stringify(scope.row.invoicingStatus) == 'null'"
                size="mini" type="primary" @click="openInvoice(scope.row)">开发票</el-button>
              <el-button v-else-if="scope.row.orderMainStatus == 3" size="mini" type="primary">
                {{ orderStatusBtn[scope.row.invoicingStatus] }}
              </el-button>

              <el-button 
              size="mini" type="primary" @click="openInvoice(scope.row)">开发票</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
        @loadTable='loadTable'></Pagination>
      <invoicePopup @update="update" ref="invoicePopup"></invoicePopup>
    </footer>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import invoicePopup from "./expendChild/invoicePopup.vue";
import OrderApi from '@/components/Api/order'

export default {
  components: {
    Pagination,
    invoicePopup,
  },
  data() {
    return {
      current: '待确认',
      value: "",
      orderStatusBtn: {
        0: '查看发票',
        1: '下载发票',
        2: '申请开票已驳回'
      },
      init: {
        "page": 1,
        "q": {
          "status": 0,
          "splitStatus": ["1A"]
        },
        "size": 10
      },
      pageSizes: [10, 20, 25, 30],
      loading: true,
      AllpagesNum: 0,
      tableData: [],
      statusDatas: [],
      payModeType: {
        0: '微信支付',
        1: '支付宝支付',
        2: '钱包支付',
        3: '线下转帐'
      },
      btnList: [
        {
          name: '全部订单',
          key: 'allOrders',
          num: 0,
          code: 0
        },
        {
          name: '待支付',
          key: 'toBePaid',
          num: 0,
          code: 1
        },
        {
          name: '操作中',
          key: 'inOperation',
          num: 0,
          code: 2
        },
        {
          name: '已关闭',
          key: 'closed',
          num: 0,
          code: 3
        }
      ],

      options: [
        {
          value: ['2A'],
          label: "待确认",
        },
        {
          value: ['3A,3B'],
          label: "待出行",
        },
        {
          value: ['4A', '4B'],
          label: "待点评",
        },
        {
          value: ['5A'],
          label: "交易完成",
        },
      ],
      options1: [
        {
          value: "选项1",
          label: "全部",
        },
        {
          value: "选项2",
          label: "PC端",
        },
        {
          value: "选项3",
          label: "小程序",
        },
      ],
    };
  },
  computed: {
    totalAmount() {
      let price = 0
      this.tableData.forEach(item => {
        price += item.orderPrice
      })
      return price.toFixed(2)
    }
  },
  watch: {},
  methods: {
    handleSelectionChange() { },
    //开发票
    openInvoice(data) {
      this.$refs.invoicePopup.init(data)
    },
    //更新列表数据
    update() {
      this.myExpensesList()
    },
    //订单状态查看
    // handlerOrderStatusClick(data) {
    //   new OrderApi("order")
    //     .statusDescription(data.id)
    //     .then((res) => {
    //       if (res.status == 200) {
    //         this.statusDatas = res.data
    //       } else {
    //         this.$message.error({ message: res.statusText });
    //       }
    //     });
    // },
    //订单详情
    handlerSeeOrderClick(data) {
      this.$emit('updateCurrent', 'detail', data)
    },
    loadTable(page, size) {
      this.init.size = size
      this.init.page = page
      this.loading = true
      this.myExpensesList()
    },
    //获取总订单了列表(我的支出)
    myExpensesList() {
      this.loading = true
      new OrderApi("order")
        .myExpenses(this.init)
        .then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.records
            this.AllpagesNum = res.data.total
            this.loading = false
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    //获取订单按钮及数量
    getOrderType() {
      new OrderApi("order")
        .orderType({})
        .then((res) => {
          if (res.status == 200) {
            this.btnList.forEach(item => {
              item.num = res.data[item.key]
            })
            console.log(this.btnList, '看坎坎坷坷22');
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    }
  },
  created() { },
  mounted() {
    this.getOrderType()
    this.myExpensesList()
  },
};
</script>
<style lang="scss" scoped>
.selsectBox {
  p {
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    cursor: pointer;

    &:hover {
      color: var(--color);
    }
  }
}

/deep/ .el-table th.el-table__cell .cell {
  color: #000 !important;
}

.active {
  background-color: #dc6d33 !important;
  color: #fff !important;
}

.expend {
  margin-bottom: 0.24rem;

  .leftLine1 {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;

    .p1 {
      color: #db6e33;
      font-size: 0.12rem;
      font-family: SourceHanSansSC-bold;
      font-weight: bold;
      width: 0.8rem;
      text-align: right;
    }

    .line {
      height: 0.3rem;
      width: 1px;
      border-right: 1px solid var(--color);
      margin: 0 0.1rem;
    }

    .btns {
      background-color: #f7e1d3;
      color: #db6e33;
    }

    .btns1 {
      background-color: #fff;
      color: #db6e33;
      border: 1px solid #db6e33;
    }

    .rightBox {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
      }
    }
  }
}

.footer {
  .footTitle {
    height: 0.5rem;
    border: 1px solid #ebeef5;
    padding: 0 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;

    .footTitleLeft {
      display: flex;
      align-items: center;

      .p1 {
        margin-right: 0.2rem;
        font-size: 0.16rem;
        font-weight: bold;
        color: #000;
      }

      .p2 {
        font-size: 0.12rem;
        margin-right: 0.2rem;

        span {
          color: red;
        }
      }
    }

    .footTitleRight {
      .btns3 {
        background-color: #fff;
        color: #db6e33;
        border: 1px solid #db6e33;
      }
    }
  }
}
</style>
